<template>
  <div class="home">
    <!-- 主內容區塊 -->
    <div class="main-content">
      <div class="banner-wrapper">
        <Banner ref="banner" />
      </div>

      <div class="tool-list" ref="toolList">
        <ToolList ref="toolListContent" />
      </div>
    </div>
    <!-- 台灣熱門精選 Bar -->
    <div class="taiwan-hot-bar">
      <h2>—臺灣熱門精選—</h2>
    </div>
    <!-- 應用領域區塊 -->
    <div class="application-section-wrapper">
      <ApplicationSection />
    </div>
  </div>
</template>


<script>
import Banner from '@/components/Banner.vue';
import ToolList from '@/components/ToolList.vue';
import ApplicationSection from '@/components/ApplicationSection.vue';

export default {
  name: 'Home',
  components: {
    Banner,
    ToolList,
    ApplicationSection,
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column; /* 確保內容垂直排列 */
  align-items: center;
  padding: 10px; /* 減少內邊距 */
  padding-left: 3%; /* 左側留白 */
  padding-right: 3%; /* 右側留白 */
}
.main-content {
  display: flex;
  justify-content: space-between; /* 左右分佈 */
  align-items: stretch; /* 確保兩側高度一致 */
  width: 100%;
  gap: 10px; /* 中間空隙 */
}

.banner-wrapper img {
  width: 100%;
  height: auto; /* 確保圖片保持比例 */
  object-fit: cover; /* 裁剪超出部分 */
}

.tool-list {
  flex: 4; /* 右邊內容占 40% */
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px; /* 確保與左邊內容分隔 */
}

.banner-wrapper {
  flex: 1; /* 每個子容器平分剩餘空間 */
  display: flex;
  flex-direction: column;


  padding: 10px; /* 減少內間距 */
}

.tool-list {
  flex: 1; /* 右邊內容占 40% */
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%; /* 同步高度 */
  overflow: hidden;
  border-left: 1px solid #ddd; /* 添加分隔線 */
  padding: 10px; /* 與左側間隔 */
}

.taiwan-hot-bar {
  width: 100%;
  text-align: center;
  background-color: #f5f5f5;
  padding: 5px 0; /* 減少內邊距 */
  margin-top: 10px; /* 減少上下間距 */
  margin-bottom: 10px;
}

.taiwan-hot-bar h2 {
  font-size: 18px; /* 調整字體大小 */
  font-weight: bold;
  color: #333;
}


/* 應用領域區塊 */
/* 應用領域區塊 */
.application-section-wrapper {
  width: 100%;
  margin-top: 20px; /* 與主內容區塊保持距離 */
}
/* RWD 支援 */
@media (max-width: 1024px) {
  .main-content {
    flex-direction: column; /* 改為垂直排列 */
    align-items: center; /* 居中對齊 */
  }

  .banner-wrapper,
  .tool-list {
    flex: none;
    width: 100%; /* 滿屏寬度 */
    aspect-ratio: auto; /* 自動調整比例 */
    height: auto; /* 高度自適應 */
  }
}

@media (max-width: 768px) {
  .home {
    padding: 5px;
  }

  .main-content {
    flex-direction: column; /* 小螢幕垂直排列 */
  }

  .banner-wrapper {
    padding: 5px; /* 減少內間距 */
    width: 100%;
    aspect-ratio: 16 / 9; /* 保持圖片比例 */
  }

  .tool-list {
    padding: 5px;
    width: 100%;
    height: auto;
  }
}


@media (max-width: 1024px) {
  .main-content {
    flex-direction: column; /* 改為垂直排列 */
    align-items: center; /* 居中對齊 */
  }

  .banner-wrapper,
  .tool-list {
    flex: none;
    width: 100%; /* 滿屏寬度 */
    aspect-ratio: auto; /* 自動調整比例 */
    height: auto; /* 高度自適應 */
  }
}

@media (max-width: 768px) {
  .home {
    padding: 5px;
  }

  .main-content {
    flex-direction: column; /* 小螢幕垂直排列 */
  }

  .banner-wrapper {
    padding: 5px; /* 減少內間距 */
    width: 100%;
    aspect-ratio: 16 / 9; /* 保持圖片比例 */
  }

  .tool-list {
    padding: 5px;
    width: 100%;
    height: auto;
  }
}

</style>
